import { inferAdditionalFields, magicLinkClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";
import { toast } from "react-hot-toast";
import { create } from "zustand";

export const authClient = createAuthClient({
  plugins: [
    magicLinkClient(),
    // Inform the client about additional fields from the server
    inferAdditionalFields({
      user: {
        isAdmin: {
          type: "boolean",
          required: false,
        },
      },
    }),
  ],
  fetchOptions: {
    credentials: "include",
  },
  // fetchOptions: {
  //   headers: {
  //     "content-type": "application/json", // necessary bugfix by https://www.answeroverflow.com/m/1347534950043484220
  //   },
  // },
});

export const {
  signIn,
  signOut,
  signUp,
  useSession,
  requestPasswordReset,
  sendVerificationEmail,
  magicLink,
} = authClient;

// Modal state store for email verification
interface EmailVerificationModalState {
  isOpen: boolean;
  email: string;
  openModal: (email: string) => void;
  closeModal: () => void;
}

export const useEmailVerificationModal = create<EmailVerificationModalState>((set) => ({
  isOpen: false,
  email: "",
  openModal: (email: string) => set({ isOpen: true, email }),
  closeModal: () => set({ isOpen: false, email: "" }),
}));

// Error handling utility for better-auth responses
export function handleAuthError(
  ret: unknown,
  defaultMessage = "Authentication failed",
  email?: string,
) {
  if (ret && typeof ret === "object" && "error" in ret && ret.error) {
    const error = ret.error as { message?: string; details?: string };
    const errorTitle = error.message ?? defaultMessage;
    const errorDetails = error.details;

    // Check if this is an email verification error
    if (errorTitle === "Email not verified" && email) {
      useEmailVerificationModal.getState().openModal(email);
      return true; // Error was handled with modal
    }

    toast.error(() => (
      <div className="flex flex-col">
        <div className="font-medium">{errorTitle}</div>
        {errorDetails && <span className="text-sm text-gray-600 mt-1">{errorDetails}</span>}
      </div>
    ));
    return true; // Error was handled
  }
  return false; // No error found, continue to other handlers
}
